import { createTheme } from '@material-ui/core/styles';
import '@fontsource/roboto';

const palette = {
  primary: {
    main: '#047EB2'
  },
  secondary: {
    main: '#333333'
  },
  danger: {
    main: '#dc4545'
  },
  light: {},
  text: {
    primary: '#000',
    secondary: '#CBCBCB',
    dark: '#fff'
  }
};
const options = {
  palette,
  typography: {
    fontFamily: ['Roboto', 'Source Sans Pro', 'Helvetica', 'Arial'].join(', ')
  }
};

const theme = createTheme(options);

export default theme;
